export default function getInitState() {
    return {
        rowActions: [
            {
                btn_text: '<i class="fas fa-edit"></i>',
                title: 'Szerkesztés',
                event_name: "customClick",
                class: "btn btn-outline-primary",
                event_payload: 'modifyRow'
            },
            {
                btn_text: '<i class="fas fa-trash"></i>',
                title: 'Törlés',
                event_name: "customClick",
                class: "btn btn-outline-danger",
                event_payload: 'deleteRow'
            },
            {
                btn_text: '<i class="fas fa-undo"></i>',
                title: 'Visszaállítás',
                event_name: "customClick",
                class: "btn btn-outline-warning",
                seeCaseOfDeleted: true,
                event_payload: 'unDeleteRow'
            }
        ],
        fixPackagesHeaderFields: [
            {
                name: "id",
                label: "ID",
                visibility: false
            },
            {
                name: "name",
                label: "Név",
                sort: true,
                formRequired: true,
                formType: "text",
                formSize: 6,
                formVisible: true
            },
            {
                name: "price",
                label: "Ár",
                visibility: true,
                formType: "number",                                                                                                                                                
                formSize: 6,
                formVisible: true,
                formRequired: true
            },
            {
                name: "duration",
                label: "Érvényesség (nap)",
                visibility: true,
                formType: "number",                                                                                                                                                
                formSize: 6,
                formVisible: true,
                formRequired: true
            },
            {
                name: "kaszCode",
                label: "KASZ kód",
                visibility: false,
                formVisible: true,
                formType: 'text',
                formSize: 6
            },
        ],
        aLaCartePackagesHeaderFields: [
            {
                name: "id",
                label: "ID",
                visibility: false
            },
            {
                name: "name",
                label: "Név",
                sort: true,
                formRequired: true,
                formType: "text",
                formSize: 6,
                formVisible: true
            },
            {
                name: "price",
                label: "Ár",
                visibility: true,
                formType: "number",                                                                                                                                                
                formSize: 6,
                formVisible: true,
                formRequired: true
            },
            {
                name: "maxSelectable",
                label: "Választható kezelések mennyisége",
                visibility: true,
                formType: "number",                                                                                                                                                
                formSize: 6,
                formVisible: true,
                formRequired: true
            },
            {
                name: "duration",
                label: "Érvényesség (nap)",
                visibility: true,
                formType: "number",                                                                                                                                                
                formSize: 6,
                formVisible: true,
                formRequired: true
            },
        ]
    }
}
